import PilotTipContainer from '@components/atoms/container/pilotTipContainer';
import Tip from '../tip/tip';
import { useAppSelector } from '@shared/store/hooks';
import { mediaSelector } from '@shared/store/slices/media.slice';
import { PlayerState } from '@shared/types/enums/player';

export default function PilotTip() {
  const { state } = useAppSelector(mediaSelector);
  if (state === PlayerState.IDLE || state === PlayerState.WAITING) {
    return null;
  }
  return (
    <PilotTipContainer>
      <Tip />
    </PilotTipContainer>
  );
}
